<template>
  <b-container fluid>
    <b-row class="mb-4 ctrl-dir">
      <b-col cols="8">
        <banner></banner>
      </b-col>
      <b-col cols="4">
        <side-bar></side-bar>
      </b-col>
    </b-row>
    <div class="w-100 my-4"></div>
    <b-row class="ctrl-dir">
      <b-col>
        <div class="home-ad">
          <b-link :href="host + homeADs[0].link" target="_blank">
            <img :src="host + homeADs[0].imgUrl" :alt="homeADs[0].title">
          </b-link>
        </div>
      </b-col>
      <b-col>
        <div class="home-ad">
          <b-link :href="host + homeADs[1].link" target="_blank">
            <img :src="host + homeADs[1].imgUrl" :alt="homeADs[1].title">
          </b-link>
        </div>
      </b-col>
    </b-row>
    <div class="w-100 my-5"></div>
    <b-row class="ctrl-dir">
      <b-col>
        <multi-search></multi-search>
      </b-col>
    </b-row>
    <div class="w-100 my-5"></div>
    <b-row class="ctrl-dir">
      <b-col>
        <link-sliders></link-sliders>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Banner from "@/components/home/Banner.vue";
import SideBar from "@/components/home/SideBar.vue";
import MultiSearch from "@/components/home/MultiSearch.vue";
import LinkSliders from "@/components/home/LinkSliders.vue";

export default {
  data() {
    return {
      homeADs: [
        {
          title: "ad",
          link: "/ads/show/13.html",
          imgUrl: "/ads/show/13.png"
        },
        {
          title: "ad",
          link: "/ads/show/8.html",
          imgUrl: "/ads/show/8.png"
        }
      ]
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    title() {
      return this.$store.state.siteSettings.title;
    },
    description() {
      return this.$store.state.siteSettings.description;
    }
  },

  components: {
    banner: Banner,
    "side-bar": SideBar,
    "multi-search": MultiSearch,
    "link-sliders": LinkSliders
  },

  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          "name": "description",
          "content": this.description
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.home-ad {
  img {
    width: 100%;
  }
}
</style>

